class Configuration {
  public static readonly API_URL = this.getEnv("VITE_API_URL", "");
  public static readonly SENTRY_CLIENT_DSN = this.getEnv("VITE_SENTRY_CLIENT_DSN", "");
  public static readonly STAGE: string = this.getEnv("VITE_STAGE", "");

  private static getEnv<T>(key: string, defaultValue?: T): T {
    const value = import.meta.env[key];

    if (value === undefined) {
      if (defaultValue !== undefined) {
        return defaultValue;
      }
      throw new Error(`Environment variable ${key} is not set`);
    }

    if (typeof defaultValue === "number") {
      return Number(value) as T;
    }

    if (typeof defaultValue === "boolean") {
      return (value.toLowerCase() === "true") as T;
    }

    return value as T;
  }
}

export default Configuration;
